module.exports = __webpack_public_path__ + "static/media/Artboard13.a29ebb50.png";